import { render, staticRenderFns } from "./Modal1.vue?vue&type=template&id=55039780&scoped=true&"
import script from "./Modal1.vue?vue&type=script&lang=js&"
export * from "./Modal1.vue?vue&type=script&lang=js&"
import style0 from "./Modal1.vue?vue&type=style&index=0&id=55039780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55039780",
  null
  
)

export default component.exports